import { render, staticRenderFns } from "./ListItemLocation.vue?vue&type=template&id=2d5f3b54&scoped=true&lang=pug"
import script from "./ListItemLocation.vue?vue&type=script&lang=js"
export * from "./ListItemLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f3b54",
  null
  
)

export default component.exports